module.exports = __webpack_public_path__ + "img/preview_sku_bg_d2c.5037cd26.png";